import { useState } from 'react';
import moment from 'moment-jalaali';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedFilter } from 'Actions';
import { FilterBox, FilterBoxDateField } from 'Elements';
import styles from 'partials/filter-box.module.scss';

export const FilterBoxStoryDate = ({ onChange }) => {
	const dispatch = useDispatch();
	const filters = useSelector((state) => state.fltr);
	const [state, setState] = useState({
		from: '',
		to: '',
		errors: {}
	});
	const selectedFilters = filters.selected_filter;

	const checkDateValidation = (range, is_moment) => {
		let isValid = true;
		if (is_moment === 'Invalid date') {
			isValid = false;
		}

		setState((prev) => ({
			...prev,
			errors: {
				...prev.errors,
				[range]: !isValid
			}
		}));

		return isValid;
	};

	const handleDateChange = (momentDate, range) => {
		// const name = selectedDate.name;
		// const dateObj = { ...state[range] };
		// dateObj[name] = selectedDate.value;

		// setState((prev) => ({
		// 	...prev,
		// 	[range]: dateObj
		// }));

		// const dateInput = `${dateObj.year}/${dateObj.month}/${dateObj.day}`;
		// const momentDate = moment(dateInput, 'jYYYY/jMM/jDD')
		// 	.startOf('day')
		// 	.format('X');

		if (checkDateValidation(range, momentDate)) {
			dispatch(
				setSelectedFilter({
					name: `${range}_date`,
					value: momentDate
				})
			);
			setState((prev) => ({
				...prev,
				[range]: momentDate
			}));
			onChange?.(range, momentDate);
		}
	};

	return (
		<FilterBox title="بازه زمانی">
			<div className={styles.dateWrapper}>
				<div className={styles.labelWrapper}>
					<span className={styles.label}>از تاریخ:</span>
					{state.from && (
						<span className={styles.labelValue}>
							{moment.unix(state.from).format('jYYYY/jMM/jDD')}
						</span>
					)}
				</div>
				<FilterBoxDateField
					range="from"
					value={selectedFilters.from_date}
					onChange={(date) => handleDateChange(date, 'from')}
				/>
				{state.errors.from && (
					<span className={styles.error}>
						لطفا تاریخ را به صورت کامل وارد کنید
					</span>
				)}
			</div>
			<div className={styles.dateWrapper}>
				<div className={styles.labelWrapper}>
					<span className={styles.label}>تا تاریخ:</span>
					{state.to && (
						<span className={styles.labelValue}>
							{moment.unix(state.to).format('jYYYY/jMM/jDD')}
						</span>
					)}
				</div>
				<FilterBoxDateField
					range="to"
					value={selectedFilters.to_date}
					onChange={(date) => handleDateChange(date, 'to')}
				/>
				{state.errors.to && (
					<span className={styles.error}>
						لطفا تاریخ را به صورت کامل وارد کنید
					</span>
				)}
			</div>
		</FilterBox>
	);
};
